import useMediaQuery from '@material-ui/core/useMediaQuery'

import { BREAKPOINTS } from 'artkive/utils/constants'

const useResponsive = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm')) // sm: 600
  const isSmDesktop = useMediaQuery((theme) => theme.breakpoints.between('sm', 'md')) // md: 960
  const isMdDesktop = useMediaQuery((theme) => theme.breakpoints.between(960, 1280)) // lg: 1280
  const isLgDesktop = useMediaQuery((theme) => theme.breakpoints.between('lg', 'xl')) // xl: 1920
  const isXlDesktop = useMediaQuery((theme) => theme.breakpoints.up('xl'))
  const isNewLgDesktop = useMediaQuery((theme) => theme.breakpoints.between('lg', BREAKPOINTS.xl))
  const isNewXlDesktop = useMediaQuery((theme) => theme.breakpoints.between(BREAKPOINTS.xl, BREAKPOINTS.xxl))
  const isNewXxlDesktop = useMediaQuery((theme) => theme.breakpoints.up(BREAKPOINTS.xxl))

  return {
    isMobile,
    isSmDesktop,
    isMdDesktop,
    isLgDesktop,
    isXlDesktop,
    isDesktop: !isMobile,

    isNewLgDesktop,
    isNewXlDesktop,
    isNewXxlDesktop,
  }
}

export default useResponsive
